import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import CasesDetailsPres from '../presentational/CasesDetailsPres';
import {
  getUserRolesSelector,
  getUserInfoSelector,
  isEYProSelector,
  isCorpClientSelector,
  isEYAdminSelector,
  isEyEngagementAdminSelector,
  isCorporateClientLineManagerSelector,
  isApplicantSelector,
  isRestrictedCorpMemberSelector,
} from 'src/ui/features/Login/state/loginReselect';
import { PageTitle } from 'src/ui/library/PageTitle';
import { updateBodyClass } from 'src/helpers';
import { BODY_CLASSES } from 'src/constants/constants.js';
import {
  updateAdditionalInfoFound,
  updateAdditionalInfoData,
  updateMainCaseInfoData,
  setNewAdditionalInfoRecord,
  setBpfStatusInfo,
} from 'src/ui/features/Cases/state/casesActions';

class CasesDetailContainer extends Component {
  componentDidMount() {
    if (this.props.isApplicant) {
      updateBodyClass(BODY_CLASSES.CASE_DETAILS_APPLICANT);
    }
  }
  componentWillUnmount() {
    if (this.props.isApplicant) {
      updateBodyClass(BODY_CLASSES.CASE_DETAILS_APPLICANT);
    }
  }
  render() {
    return (
      <React.Fragment>
        <PageTitle title={intl.get('cases.details.pageTitle')} />
        <CasesDetailsPres {...this.props} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    bpfStatusInfo,
    isAdditionalInfoSecExist,
    hasAdditionalInfo,
    additionalInfoData,
    caseInfoData,
    newAdditionalInfoRecordId,
  } = state.cases;
  return {
    userInfo: getUserInfoSelector(state),
    userRoles: getUserRolesSelector(state),
    isEYPro: isEYProSelector(state),
    isEYAdmin: isEYAdminSelector(state),
    isCorpClient: isCorpClientSelector(state),
    isCorpClientLineManager: isCorporateClientLineManagerSelector(state),
    isEyEngagementAdmin: isEyEngagementAdminSelector(state),
    isApplicant: isApplicantSelector(state),
    isRestrictedCorpMember: isRestrictedCorpMemberSelector(state),
    bpfStatusInfo,
    isAdditionalInfoSecExist,
    hasAdditionalInfo,
    additionalInfoData,
    caseInfoData,
    newAdditionalInfoRecordId,
  };
};

const mapDispatchToProps = {
  setBpfStatusInfo,
  updateAdditionalInfoFound,
  updateAdditionalInfoData,
  updateMainCaseInfoData,
  setNewAdditionalInfoRecord,
};

export default connect(mapStateToProps, mapDispatchToProps)(CasesDetailContainer);
